import { Component } from '@angular/core';
import { UtilityService } from '@granit/common-library';
import { Felhasznalo, FelhasznaloService } from '@granit/portal-library';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'ClientApp';  

  aktualisFelhasznalo: Felhasznalo;
  constructor(private felhasznaloService: FelhasznaloService,
    private utilityService: UtilityService) { }

  ngOnInit(): void {
    let model = {
      alkalmazasEnum: 7,
      formGroupValue: null
    };
    this.felhasznaloService.bejelentkezes(model).subscribe(
      adat => {        
        this.aktualisFelhasznalo = adat;        
      },
      errorResult => {
        this.utilityService.dialogMegnyitasa({
          error: true,
          title: 'Indítás',
          message: "Hiba az indítás közben",
          confirmButtonText: 'Rendben'
        }, "800px");
      });
  }

  ngAfterViewInit() {
    this.relocateRecaptchaIframe();
  }
  
  relocateRecaptchaIframe() {    
    const badge = document.querySelector('.grecaptcha-badge');
    const wrapper = document.getElementById('recaptcha-landmark-wrapper');

    if (badge && wrapper) {
      const badgeParent = badge.parentNode;
      wrapper.appendChild(badgeParent); // teljes badge dobozt mozgatunk
    }
  }  
}
